import playerApiRequest from '../../../utils/playerApiRequest'

export default function requestVodContent({
  playerApiRefId,
  type,
  groupToken,
}) {
  return playerApiRequest({
    path: type === 'shortform'
      ? `shortform/${playerApiRefId}`
      : `episodes/${playerApiRefId}`,
    params: {
      groupToken,
    },
  })
}
